module.exports = __webpack_public_path__ + "img/logo-dark.e191376a.png";